import { View } from "react-native";
import React, { useState } from "react";
import { useRouter, useNavigation } from "expo-router";
import { useAuth } from "@components/auth/useAuth";

import ThemedScreen from "@/components/ThemedScreen";
import { CustomAlert } from "@/components/ThemedAlert";
import { ThemedProgressBar } from "@/components/ThemedProgressBar";

import { useFirebase } from "@components/firebase/useFirebase";
import { createAnchor } from "@/services/firebase/anchor-functions";
import { AnchorEditor } from "@/components/anchors/AnchorEditor";
import { navigateBackOrToList } from "@/utils/navigation";

/**
 * Screen for creating a new Anchor entity.
 */
export default function NewAnchorScreen(): React.JSX.Element {
  const services = useFirebase();
  const { user } = useAuth(true);
  const router = useRouter();
  const navigation = useNavigation();

  const [isSaving, setIsSaving] = useState(false);

  const handleSave = async (formData: any) => {
    if (!services) return;

    setIsSaving(true);
    try {
      const res = await createAnchor(services, {
        ...formData,
      });

      if (res.status) {
        navigateBackOrToList(router, "/(tabs)/my-anchors", navigation);
      } else {
        CustomAlert.alert("Error", res.error || "Failed to create anchor.");
      }
    } catch (error: any) {
      console.error("Error creating anchor:", error);
      CustomAlert.alert("Error", error.message || "Unexpected error while saving.");
    } finally {
      setIsSaving(false);
    }
  };

  return (
    <ThemedScreen title="New Anchor" loading={isSaving}>
      <View style={{ flex: 1 }}>
        <ThemedProgressBar loading={isSaving} />
        <AnchorEditor
          currentUserId={user?.uid}
          onSave={handleSave}
          onCancel={() => navigateBackOrToList(router, "/(tabs)/my-anchors", navigation)}
          isSaving={isSaving}
          submitTitle="Create Anchor"
        />
      </View>
    </ThemedScreen>
  );
}
